import { CHAT_SUGGESTION_PROMPTS } from "../constants/chatSuggestions";

interface Props {
  onPick: (prompt: string) => void;
  disabled?: boolean;
}

export default function ChatPromptChips({ onPick, disabled }: Props) {
  return (
    <div className="border-t border-slate-100 bg-slate-50/80 flex-shrink-0">
      <div className="max-w-3xl mx-auto px-4 md:px-6 pt-3 pb-0">
        <p className="text-[11px] font-medium uppercase tracking-wider text-slate-400 mb-2">
          Gợi ý nhanh
        </p>
        <div className="flex gap-2 overflow-x-auto pb-3 -mx-1 px-1">
          {CHAT_SUGGESTION_PROMPTS.map((item) => (
            <button
              key={item.label}
              type="button"
              disabled={disabled}
              onClick={() => onPick(item.prompt)}
              className="flex-shrink-0 max-w-[220px] text-left px-3 py-2 rounded-lg border border-slate-200 bg-white text-sm text-slate-800 hover:border-slate-300 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 disabled:opacity-50 disabled:pointer-events-none transition-colors"
            >
              <span className="line-clamp-2 leading-snug">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
